<script>
    import TheSvgIcon from "@main/packages/TheSvgIcon";

    export default {
        name: "TheSliderArrow",
        components: {
            TheSvgIcon,
        },
        props: {
            className: {
                type: Array,
                default: () => [],
            },
            /** @type {import('vue').PropOptions<"prev" | "next">} */
            type: {
                type: String,
                validator: (v) => ["prev", "next"].includes(v),
            },
        },
        computed: {
            computeClassName() {
                return [
                    ...[`swiper-button-${this.type}`, `c-slider__arrow--${this.type}`],
                    ...this.className,
                ];
            },
        },
    };
</script>

<template>
    <button class="c-slider__arrow outline" :class="computeClassName">
        <the-svg-icon name="arrow" :size-w="24"></the-svg-icon>
    </button>
</template>

<style lang="scss">
    .c-slider__arrow {
        display: flex;
        align-items: center;
        justify-content: center;
        @include box(40px);
        border-radius: 50%;
        background-color: var(--slider-arrow-bg);
        margin-top: 0;
        transform: translateY(-50%);
        outline: none;
        svg {
            fill: #fff;
        }

        &:after {
            display: none;
        }

        &.swiper-button-disabled {
            opacity: 0 !important;
        }
    }

    .c-slider__arrow--next {
        svg {
            transform: rotate(180deg);
        }
    }

    .c-slider__arrow--bottom {
        background-color: transparent;
        transition: 0.3s ease-in-out all;
        svg {
            fill: #182028;
        }
        @include bp($bp-desktop-sm) {
            position: relative;
            display: flex;
            @include box(32px);
            transform: none;
        }
        &[aria-disabled="true"],
        &.swiper-button-disabled {
            opacity: 0.3 !important;
        }
        &.c-slider__arrow--prev {
            left: auto;
            margin-right: 30px;
        }
        &.c-slider__arrow--next {
            right: auto;
            margin-left: 30px;
        }
    }
</style>
